export enum ModeloTextoCustomizadoEnum {
    INSTRUCOES_USO = 1,
    TERMO_RESPONSABILIDADE = 2,
    NOTIFICACAO_CONFIRMATION_EMAIL_SUBJECT = 3,
    NOTIFICACAO_CONFIRMATION_EMAIL_BODY = 4,
    NOTIFICACAO_DAILY_EMAIL_SUBJECT = 5,
    NOTIFICACAO_DAILY_EMAIL_BODY = 6,
}
